import { Injectable } from '@angular/core';
import { Logger } from './chatbot-logger.service'
import { MessageBus } from './service-bus.service'
import { LivechatHttpClientService } from './livechat-http-client.service'
import * as moment from 'moment';
import { chatStateMachineConfig } from './machineDef';
import { ChatMachineStatesEnum, ChatAvailabilityStateEnum, ChatMachineSchema, ChatMachineEvent, ChatMachineEventEnum } from './interfaces-livechat';
import { IMessage, IdOptions, GlobalStateEnum } from './interfaces'
import { Observable, timer, Subscription, from, interval } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Howl, Howler } from 'howler';



import {
  interpret,
  Machine,
  MachineOptions,
  State,
  assign,
  EventObject,
  AssignMeta
} from 'xstate';
@Injectable({
  providedIn: 'root'
})


export class ChatStateMachine {
  private messageBus: MessageBus
  private machineEventSub: Subscription
  private livechatClient: LivechatHttpClientService

  //global state
  globalStateEnum = GlobalStateEnum
  globalState: GlobalStateEnum = GlobalStateEnum.BOT_OFFLINE

  /*  
    provozní doby livechatu (08-22h/7d).
  */
  beforeTime = moment('08:00', "HH:mm")
  afterTime = moment('22:00', "HH:mm")

  LV_OP_IMMEDIATE_START_STEP1: string = `Zahajuji přepojení na operátora.`
  LV_ERR_ON_HOURS_OK_OPS_MSG: string = `Naši operátoři jsou Vám k dispozici kdykoliv v době od 8 do 22
  hodin, 7 dní v týdnu. Mimo pracovní dobu nás neváhejte kontaktovat e-mailem na adrese <a href="mailto:dotazy@scitani.cz">dotazy@scitani.cz</a>, rádi váš dotaz zodpovíme v co nejkratším možném
  termínu.`
  LV_ERR_ON_HOURS_NO_OPS_MSG: string = `Momentálně nejsou
  k dispozici operátoři na online chatu. Naši operátoři jsou Vám k dispozici kdykoliv v době od 8 do 22 hodin, 7 dní v týdnu. Mimo
  pracovní dobu nás neváhejte kontaktovat e-mailem na adrese 
  <a href="mailto:dotazy@scitani.cz">dotazy@scitani.cz</a>. Rádi Váš dotaz zodpovíme v co nejkratším možném termínu. Můžete také využít nápovědu <a href=\"https://www.scitani.cz/formular\" target=\"_blank\">www.scitani.cz/formular</a> a často kladené dotazy <a href=\"https://www.scitani.cz/faq\" target=\"_blank\">www.scitani.cz/faq</a> na webu scitani.cz.     `


  LV_ERR_OFF_HOURS_MSG: string = `Momentálně nejsou k dispozici operátoři na online chatu. Naši
  operátoři jsou Vám k dispozici kdykoliv v době od 8 do 22 hodin, 7 dní v týdnu. Mimo
  pracovní dobu nás neváhejte kontaktovat e-mailem na adrese <a href="mailto:dotazy@scitani.cz">dotazy@scitani.cz</a>. Rádi Váš
  dotaz zodpovíme v co nejkratším možném termínu. Můžete také využít nápovědu <a href=\"https://www.scitani.cz/formular\" target=\"_blank\">www.scitani.cz/formular</a> 
  a často kladené dotazy <a href=\"https://www.scitani.cz/faq\" target=\"_blank\">www.scitani.cz/faq</a> na webu scitani.cz.`


  LV_OP_NOT_AVAILABLE_END_STEP1: string = `Všichni naši operátoři jsou momentálně vytíženi, prosím vyčkejte na spojení s operátorem.`
  LV_OP_NOT_AVAILABLE_START_STEP2: string = `Vyčkejte na spojení s operátorem.`
  LV_OP_NOT_AVAILABLE_END_STEP2: string = `Omlouváme se, ale momentálně není k dispozici operátor, který by mohl Váš požadavek vyřídit. Prosím kontaktujte nás e-mailem na adrese <a href="mailto:dotazy@scitani.cz">dotazy@scitani.cz</a> nebo se zkuste s operátorem spojit později, děkujeme za pochopení.<br/>
  Můžete také využít nápovědu <a href=\"https://www.scitani.cz/formular\" target=\"_blank\">www.scitani.cz/formular</a> 
  a často kladené dotazy <a href=\"https://www.scitani.cz/faq\" target=\"_blank\">www.scitani.cz/faq</a> na webu scitani.cz.`


  LV_USER_ENDED_WAITING_FOR_OP_MSG: string = `Čekání na spojení s operátorem bylo ukončeno.`
  LV_OP_ENDED_CHAT_MSG: string = `Spojení s operátorem bylo ukončeno.`

  LV_USER_START_WAITING_FOR_GDPR_CONSENT_MSG: string = `Tento chat bude zaznamenán za účelem zkvalitnění poskytovaných služeb provozovatelem kontaktního centra společností Conectart. Souhlasíte-li stiskněte ANO, v případě nesouhlasu stiskněte NE a kontaktujte nás prosím jiným způsobem.`
  LV_USER_ENDED_WAITING_FOR_GDPR_CONSENT_MSG: string = `Čekání na spojení s operátorem bylo ukončeno.`
  //LV_CANCEL_WAIT_OP_MSG: string = "Ukončili jste požadavek na spojení s operátorem"


  LV_DONT_BROWSE_IN_THIS_WINDOW_ONLINE = "Při čekání na operátora neopouštějte web onlinescitani.cz. V případě potřeby si otevřete další záložku Vašeho prohlížeče. <br/>Budete upozorněni zvukovým signálem, že je vyžadována Vaše součinnost při čekání na operátora."

  LV_DONT_BROWSE_IN_THIS_WINDOW_WEB = "Při čekání na operátora nepřecházejte v tomto okně na jinou stránku. V případě potřeby si otevřete další záložku Vašeho prohlížeče. <br/>Budete upozorněni zvukovým signálem, že je vyžadována Vaše součinnost při čekání na operátora."
  LV_DONT_BROWSE_IN_THIS_WINDOW = ""

  public activeMachine: any
  private apikey2: string

  /*  THEORY:
  local storage:
  https://github.com/davidkpiano/xstate/blob/master/docs/guides/states.md
  https://spectrum.chat/statecharts/general/restoring-state-from-localstorage-in-a-react-app-with-usemachine~e0f7c801-94ab-4bb9-a680-c8a9ea689807
  
  */

  soundNotification: any


  constructor(messageBus: MessageBus, livechatClient: LivechatHttpClientService) {
    this.messageBus = messageBus
    this.livechatClient = livechatClient
    this.LV_DONT_BROWSE_IN_THIS_WINDOW = this.LV_DONT_BROWSE_IN_THIS_WINDOW_ONLINE
  }

  createMsg(msg: string, from: IdOptions, mode, loading): IMessage {
    return {
      from: {
        avatar: "",
        id: from,
        name: "",
        photo: ""
      },
      message: [msg],
      message2: [],
      timeStamp: moment().toISOString(),
      generic: {},
      parsedMessage: "",
      parsedButtons: [],
      shouldDisplayButtons: false,
      index: mode, //bud -1 pro BEZ animace, nebo -2 specialni animacni zprava pri cekani na operatora
      loading: loading
    }
  }

  chatMachineOptions: Partial<MachineOptions<any, any>> = {
    services: {
      waitForOperatorToPickChat: (context, event) => {
        //console.log("FSM: waitForOperatorToPickChat")
        /*
        return interval(1000).pipe(
          map((value) => ({ type: 'REPEAT_READ_MESSAGE', value })),
          take(2)
        )
        */
        return interval(1000)
      }
    },
    guards: {

      areChatWorkingHoursOn: (context, event) => {
        Logger.info(`Checking time: ${moment().toISOString()}`)
        //console.log(`Checking time: ${moment().toISOString()}`)
        if (moment().isBetween(this.beforeTime, this.afterTime)) {
          Logger.info('ON: LV is open for business')
          return true
        } else {
          //console.log('ON: LV is closed for business')

          return false
        }
      },
      areChatWorkingHoursOff: (context, event) => {
        Logger.info('OFF: LV is closed for business')
        return !moment().isBetween(this.beforeTime, this.afterTime)
      }

    },
    actions: {
      updateContext: assign((context, event, meta) => {

        //console.log(`Before: ${JSON.stringify(context)}`),
        //console.log(`update context: ${JSON.stringify(meta)}`)
        //  //console.log(`update context: ${JSON.stringify(meta)}`)
        return {

          isError: event.value.isError == null ? context.isError : event.value.isError,
          waitForOpCounter: event.value.waitForOpCounter == null ? context.waitForOpCounter : context.waitForOpCounter += event.value.waitForOpCounter,
          states: [...context.states, meta.state.value],
          events: [...context.events, event.type]
        }
      }),


      sendMessageBotErrChatOff: () => {
        this.messageBus.publishMessageToBus(this.createMsg(this.LV_ERR_OFF_HOURS_MSG, "xbot", -1, false))
      },
      sendMessageBotErrChatOn: () => {
        this.messageBus.publishMessageToBus(this.createMsg(this.LV_ERR_ON_HOURS_OK_OPS_MSG, "xbot", -1, false))
      },
      sendMessageBotErrChatErr: () => {
        this.messageBus.publishMessageToBus(this.createMsg(this.LV_ERR_ON_HOURS_NO_OPS_MSG, "xbot", -1, false))

      },
      sendMessageBotErrChatBusy: () => {
        this.messageBus.publishMessageToBus(this.createMsg(this.LV_ERR_ON_HOURS_NO_OPS_MSG, "xbot", -1, false))

      },
      sendMessageStartOfWaitingForOp1: () => {
        setTimeout(() => {
          if (this.activeMachine.state.value == ChatMachineStatesEnum.opWaitingForOp1 ){
            this.messageBus.publishMessageToBus(this.createMsg(this.LV_OP_IMMEDIATE_START_STEP1, "op", -2, false))
          }
        }, 10000)
      },
      sendMessageDontBrowseInThisWindow: () => {
        setTimeout(() => {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_DONT_BROWSE_IN_THIS_WINDOW, "op", -2, false))
        }, 0)
      },
      sendMessageEndOfWaitingForOp1: () => {
        setTimeout(() => {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_OP_NOT_AVAILABLE_END_STEP1, "op", -2, false))
        }, 0)
      },

      sendWaitingMessageForOp1_2: () => {
        setTimeout(() => {
          if (this.activeMachine.state.value == ChatMachineStatesEnum.opWaitingForOp1 || this.activeMachine.state.value == ChatMachineStatesEnum.opWaitingForOp2) {
            this.messageBus.publishMessageToBus(this.createMsg(this.LV_OP_NOT_AVAILABLE_END_STEP1, "op", -2, false))
          }
        }, 25000)
      },
      sendMessageStartOfWaitingForOp2: () => {
        setTimeout(() => {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_OP_NOT_AVAILABLE_START_STEP2, "op", -2, false))
        }, 0)
      },
      sendMessageEndOfWaitingForOp2: () => {
        setTimeout(() => {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_OP_NOT_AVAILABLE_END_STEP2, "op", -1, false))
        }, 0)

      },

      sendMessageCancelWaitingForOpByUser: () => {
        setTimeout(() => {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_USER_ENDED_WAITING_FOR_OP_MSG, "op", -1, false))
        }, 0)

      },
      sendMessageStartOfWaitingForGdprConsent: () => {
        setTimeout(() => {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_USER_START_WAITING_FOR_GDPR_CONSENT_MSG, "op", -1, false))
        }, 0)

      },
      sendMessageCancelWaitingForGdprConsentByUser: () => {
        setTimeout(() => {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_USER_ENDED_WAITING_FOR_GDPR_CONSENT_MSG, "op", -1, false))
        }, 0)

      },
      sendMsgLivechatConnClosed: () => {
        setTimeout(() => {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_OP_ENDED_CHAT_MSG, "op", -1, false))


        }, 500)
      },

      checkChatAvailabilityStatus: () => {
        //Inicializace LV client -> musi se presunout az do otevreni dialogu (jinak se bude zbytecne volat pro kazdou web stranku)
        this.livechatClient.setOptionsAndCheckAvailabilityStatus(this.apikey2,false)
      },



      makeEndChatApiCall: () => {
        this.livechatClient.endChatReq()
      },

      /*
        publikuje i status
      */

      publishMachineEventToBus: () => {
        if (this.activeMachine.state.value == ChatMachineStatesEnum.opFeedback) {
          this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_FEEDBACK)
        }

        this.messageBus.publishMachineStateToBus(this.activeMachine.state.value)
      },


      saveBotAvailabilityStatus: (context, event: ChatMachineEvent) => {
        Logger.info(`-----------------------> saveBotAvailabilityStatus. context: ${JSON.stringify(context)}, event: ${JSON.stringify(event)}`)
        if (event && event.type == 'BOT_OFFLINE') {
          this.globalState = GlobalStateEnum.BOT_OFFLINE
        } else if (event && event.type == 'BOT_ONLINE') {
          this.globalState = GlobalStateEnum.BOT_ONLINE
        }

      },

      playNotificationOnWaitForUser: () => {
        this.soundNotification.play()

      },

      playNotificationOnOpStart: () => {
        this.soundNotification.play()
      }



    }
  };

  private _machine = Machine<any, ChatMachineSchema, ChatMachineEvent>(chatStateMachineConfig).withConfig(this.chatMachineOptions);

  /* local-storage serializace
  https://github.com/davidkpiano/xstate/blob/master/docs/guides/states.md
   */

  public init(apikey: string, url: string,mode: string) {
    this.apikey2 = apikey

    this.soundNotification = new Howl({
      src: [url]
    });

    if (mode == 'portal'){
      this.LV_DONT_BROWSE_IN_THIS_WINDOW = this.LV_DONT_BROWSE_IN_THIS_WINDOW_WEB
    } else {
      this.LV_DONT_BROWSE_IN_THIS_WINDOW = this.LV_DONT_BROWSE_IN_THIS_WINDOW_ONLINE
    }

    /* nacteni predchozi ulozene definice stavu z local-storage a obnoveni
    /* Zruseno - prilis komplexni

    let previousDef = null
    let shouldRunNew = true

    try {
      previousDef = JSON.parse(localStorage.getItem('unitx-chatbot-app-state'))
    } catch (err) {
      Logger.error(`Failed to load state from local storage: ${JSON.stringify(err)}`)
    }

    if (previousDef) {
      try {
        console.log(`Previous state loaded with value: ${JSON.stringify(previousDef)}`)
        Logger.info(`Previous state loaded with value: ${JSON.stringify(previousDef)}, saved at: ${previousDef.timestamp} in state: ${previousDef.stateStr}`)
        const previousState: State<any,any,any> = State.create(previousDef.stateObj);


        const resolvedState: State<any,any,any> = this._machine.resolveState(previousState);
        this.activeMachine = interpret(this._machine)
        this.activeMachine.start(resolvedState);
        shouldRunNew = false
        this.getState()
      } catch (err) {
        Logger.error(`Resolve and interpret loaded state failed. error: ${JSON.stringify(err)}`)
        try {
          localStorage.removeItem('unitx-chatbot-app-state')
        } catch (err) {
          Logger.error(`Local storage failed to remove item. Error: ${JSON.stringify(err)}`)
        }

      }
    }
    
    //Standardni/nova inicializace bez predchozi historie
    if (shouldRunNew) {

      this.activeMachine = interpret(this._machine, { devTools: true }).start();
    }
    */

    this.activeMachine = interpret(this._machine, { devTools: true }).start();
    let stateStr = JSON.stringify(this.activeMachine.state.value)
    Logger.info(`FSM initiated with state: ${stateStr}`)

    /*
    REgistrace na STATUS update message bus - jedina integrace s LV klientem, ZPRAVY z BUSu maji stejny enum jako eventy FSM

    PREVADI SE NA fsm stavy
    */
    this.machineEventSub = this.messageBus.getMachineEventFromBus().subscribe(status => {
      //console.log('#'.repeat(100))
      Logger.info(`FSM: got new EVENT from status bus: ${JSON.stringify(status)}, current state: ${this.activeMachine.state.value}`)
      //console.log('#'.repeat(100))
      if (status) {

        //Logika pro prechod do dalsiho FSM stavu 

        //Uvodni vyhodnoceni v pripade BOT OK/ERR
        if (this.globalState == GlobalStateEnum.BOT_ONLINE) {
          if (status == ChatMachineEventEnum.OP_ONLINE) {
            this.updateState({ type: ChatMachineEventEnum.OP_ONLINE, value: {} })

          } else if (status == ChatMachineEventEnum.OP_BUSY) {
            this.updateState({ type: ChatMachineEventEnum.OP_BUSY, value: {} })

          } else if (status == ChatMachineEventEnum.OP_OFFLINE) {
            this.updateState({ type: ChatMachineEventEnum.OP_OFFLINE, value: {} })
          }
        } else if (this.globalState == GlobalStateEnum.BOT_OFFLINE) {
          if (status == ChatMachineEventEnum.OP_ONLINE) {
            this.updateState({ type: ChatMachineEventEnum.OP_ONLINE_CHAT_ERR, value: {} })

          } else if (status == ChatMachineEventEnum.OP_BUSY) {
            this.updateState({ type: ChatMachineEventEnum.OP_BUSY_CHAT_ERR, value: {} })

          } else if (status == ChatMachineEventEnum.OP_OFFLINE) {
            this.updateState({ type: ChatMachineEventEnum.OP_OFFLINE_CHAT_ERR, value: {} })
          }
        }

        if (status == ChatMachineEventEnum.OP_DID_NOT_START) {
          this.updateState({ type: ChatMachineEventEnum.OP_DID_NOT_START, value: {} })

        }

        if (status == ChatMachineEventEnum.OP_FEEDBACK) {
          this.updateState({ type: ChatMachineEventEnum.OP_FEEDBACK, value: {} })

        }

        if (status == ChatMachineEventEnum.OP_DID_START) {
          this.updateState({ type: ChatMachineEventEnum.OP_DID_START, value: {} })

        }

        if (status == ChatMachineEventEnum.OP_UNEXPECTED_ERR) {
          this.updateState({ type: ChatMachineEventEnum.OP_UNEXPECTED_ERR, value: {} })
        }




      } else {

      }
    })
  }

  public async updateState(newState: any) {
    Logger.info('*'.repeat(100))
    Logger.info('*'.repeat(100))
    Logger.info(`FSM got update state  event request: ${JSON.stringify(newState)} from state: ${this.activeMachine.state.value}`)
    await this.activeMachine.send(newState)
    let stateStr = JSON.stringify(this.activeMachine.state.value)
    Logger.info('*'.repeat(100))
    Logger.info(`FSM changed to state: ${stateStr}`)
    //console.log(`FSM changed to state: ${stateStr}`)
    Logger.info('*'.repeat(100))

    /* 11.2.21 serializace pro nacteni ulozeneho stavu FSM*/
    /* Zruseno - prilis komplexni
    try {
      let state = {
        timestamp: moment().toISOString(),
        stateObj: this.activeMachine.state,
        stateStr: stateStr
      }

      localStorage.setItem('unitx-chatbot-app-state', JSON.stringify(state));
      Logger.info(`Current state saved to local storage with value: ${JSON.stringify(state)}`)
    } catch (err) {
      // unable to save to localStorage
      Logger.error(`Local storage is not supported. Error: ${JSON.stringify(err)}`)
    }
    */

  }

  public getState(): ChatMachineStatesEnum {
    Logger.info('*'.repeat(100))
    // //console.log(`FSM got get state request: ${JSON.stringify(this.activeMachine.state)}`)
    let stateStr = this.activeMachine.state.value
    Logger.info('*'.repeat(100))
    Logger.info(`FSM current state: ${stateStr}`)
    //console.log(`FSM current state: ${stateStr}`)
    Logger.info('*'.repeat(100))
    return stateStr
  }
}
